"use strict";

import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class AppService {
    getDownloadBrowsersInfo () {
        const query = "auth/GetSupportedBrowsers";
        return axios.post(UrlHelper.getIdentifiUrl() + query);
    }
}

export default new AppService;
